"use client";

import { Button } from "@/components/ui/button";
const HERO_IMAGE = "https://ideal-jay.10web.cloud/wp-content/uploads/2026/07/landinghero-1.png";
export default function GolfResortPartnerHero() {
  const scrollToEnquiry = () => {
    document.getElementById("partner-enquiry")?.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  };
  const scrollToBenefits = () => {
    document.getElementById("partner-benefits")?.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  };
  return <section id="golfresortpartnerhero" aria-label="Partner with TeeListClub" className={["relative w-full overflow-hidden", "h-[640px]", "md:h-[700px]", "lg:h-[800px]", "bg-[#F7F3E9]"].join(" ")} style={{
    fontFamily: '"Raleway", Arial, sans-serif'
  }}>
      {}
      <img src={HERO_IMAGE} alt="Premium golf course and resort clubhouse" loading="eager" fetchPriority="high" className="absolute inset-0 w-full object-cover object-[64%_center] ![margin:20px_0px_20px_0px] !h-[800px]" />

      {}
      <div aria-hidden="true" className={["pointer-events-none absolute inset-0", "bg-[linear-gradient(90deg,rgba(247,243,233,0.98)_0%,rgba(247,243,233,0.92)_23%,rgba(247,243,233,0.58)_42%,rgba(247,243,233,0.14)_61%,rgba(247,243,233,0)_76%)]"].join(" ")} />

      {}
      <div className="relative z-10 mx-auto flex h-full w-full max-w-[1600px] items-center ![padding:100px_64px_0px_64px]">
        <div className="relative max-w-[690px]">
          {}
          <div className={["mb-7 inline-flex items-center", "rounded-[9px]", "border border-[#B79A5F]/45", "bg-[#FFFDF7]/72", "px-4 py-2", "shadow-sm", "backdrop-blur-[8px]"].join(" ")}>
            <span className={["text-[11px] font-bold uppercase", "tracking-[0.16em]", "text-[#073F31]"].join(" ")}><span className="!font-extrabold text-secondary"><span className="text-secondary"><span className="text-primary">For Golf Courses &amp; Resorts</span></span></span></span>
          </div>

          {}
          <h1 className={["tlc-partner-hero-title", "max-w-[680px]", "text-[52px]", "leading-[0.98]", "tracking-[-0.045em]", "text-[#073F31]", "sm:text-[60px]", "md:text-[70px]", "lg:text-[82px]"].join(" ")}>
  Partner with
  <br />
  TeeListClub.
        </h1>

          {}
          <p className={["mt-7 max-w-[590px]", "text-[16px] font-medium", "leading-[1.7]", "text-[#29483E]", "md:text-[18px]"].join(" ")}>
            Present your course professionally, reach relevant golf travellers
            and explore partnership opportunities built around your business
            priorities.
          </p>

          {}
          <div className="mt-9 flex flex-col gap-4 sm:flex-row sm:items-center">
            <Button type="button" onClick={scrollToEnquiry} className="inline-flex items-center justify-center gap-2 whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive py-2 has-[>svg]:px-3 h-[54px] min-w-[214px] rounded-[9px] bg-[#BFFF00] px-7 font-bold uppercase tracking-[0.075em] text-[#073F31] shadow-[0_9px_24px_rgba(7,63,49,0.18)] transition-all duration-300 !text-xs disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:-translate-y-[2px] hover:bg-[#CBFF36]">
              Discuss a Partnership
            </Button>

            <Button type="button" variant="outline" onClick={scrollToBenefits} className="inline-flex items-center justify-center gap-2 whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive shadow-xs py-2 has-[>svg]:px-3 h-[54px] min-w-[196px] rounded-[9px] border border-[#D7C6A4]/50 bg-[#FFFDF7]/45 px-7 font-bold uppercase tracking-[0.07em] text-[#073F31] backdrop-blur-[8px] transition-all duration-300 !text-xs disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50 hover:-translate-y-[2px] hover:border-[#073F31] hover:bg-[#FFFDF7]/78">
              View Benefits
            </Button>
          </div>
        </div>
      </div>
    </section>;
}